<template>
  <div class="Approval-list">
    <div class="top-con">
      <h3 v-if="routId==1">{{$t('ApprovedList')}}</h3>
      <h3 v-else>{{$t('PendingApprovalList')}}</h3>
      <div class="time">
        <div class="l">
          <dateTimePicker
            :type="'date'"
            v-model="TargetDate"
            :placeholder="$t('PleaseSelectTime')"
            @change="handleDateChange"
            :hasclass="'no-style'"
          ></dateTimePicker>
        </div>
        <div class="r">
          <div class="button" @click="search">{{$t('Search')}}</div>
        </div>
      </div>
    </div>
    <div v-if="List.length > 0">
      <div class="list" v-for="(item) in List" :key="item.ticketId">
        <router-link :to="`/carrier/invitationDetail/${item.ticketId}`">
          <div
            class="title"
          >{{item.invitationDate}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.invitationTime}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.areaName}}</div>
          <div class="row">
            <div class="col-8">
              <div class="dock-name">{{item.dockName}}</div>
              <p v-for="car in item.cars" :key="car">{{car}}</p>
            </div>
            <div class="col-4 r">
              <span
                :class="item.checkStatus == 2 ? 'status-green': (item.checkStatus == 1 ? 'status-grey': 'status-red') "
              >{{item.checkStatusDesc}}</span>
              <i class="iconfont icon-right"></i>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div v-else>
      <div class="des" v-if="routId==1">{{$t('NoApprovedRecords')}}</div>
      <div class="des" v-else>{{$t('NoPendingApprovalRecord')}}</div>
    </div>
    <div
      v-if="totalPages > pageIndex"
      :class="isHasSearch ? 'load-more rel': 'load-more'"
      @click="showMore"
    >{{$t('ViewMore')}}</div>
    <div class="go-top" @click="goTop" v-if="pageIndex>=2">
      <i class="iconfont icon-up"></i>
    </div>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
    <div class="row fixed-con">
      <div class="col-4">
        <router-link to="/carrier/invitationlist/0">
          <span>{{$t('approvaling')}}</span>
        </router-link>
      </div>
      <div class="col-4 c">
        <router-link to="/carrier/invitationlist/1">
          <span>{{$t('approved')}}</span>
        </router-link>
      </div>
      <div class="col-4">
        <router-link to="/carrier/carlist">
          <span>{{$t('VehicleManagement')}}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { GetCarrierinvitationCheckList } from "@/utils/api";
import { checkNested } from "@/utils/utils";
import Loading from "vue-loading-overlay";
import dateTimePicker from "@/components/dateTimePicker.vue";
export default {
  name: "pendingApproval",
  components: {
    Loading,
    dateTimePicker
  },
  data() {
    return {
      routId: 0,
      TargetDate: "",
      IsChecked: false,
      pageIndex: 1,
      pageCount: 5,
      totalPages: 0,
      List: [],
      isLoading: false,
      isHasSearch: true
    };
  },
  created() {
    const routeID = this.$route.params.id;
    console.log(this.$route);
    this.routId = routeID;
    routeID == "1" ? (this.IsChecked = true) : (this.IsChecked = false);

    let QueryModel = {
      TargetDate: this.TargetDate,
      IsChecked: this.IsChecked
    };

    this.getCarrierinvitationCheckList(
      this.pageIndex,
      this.pageCount,
      QueryModel
    );
  },
  watch: {
    $route: function() {
      const routeID = this.$route.params.id;
      this.routId = routeID;
      routeID == "1" ? (this.IsChecked = true) : (this.IsChecked = false);

      let QueryModel = {
        TargetDate: "",
        IsChecked: this.IsChecked
      };
      this.TargetDate = "";
      this.List = [];
      this.getCarrierinvitationCheckList(1, this.pageCount, QueryModel);
    }
  },
  methods: {
    getCarrierinvitationCheckList(pageIndex, pageCount, queryModel) {
      this.isLoading = true;
      GetCarrierinvitationCheckList(pageIndex, pageCount, queryModel)
        .then(res => {
          if (checkNested(res, "data", "content", "model")) {
            this.isLoading = false;
            let listData = res.data.content.model.entities;
            console.log(res.data.content.model);
            if (listData) {
              this.pageIndex = res.data.content.model.pageIndex;
              this.totalPages = res.data.content.model.totalPages;
              if (this.List.length) {
                this.List = this.List.concat(listData);
              } else {
                this.List = listData;
              }
            } else {
              this.List = [];
            }
          } else {
            this.$router.push({ path: "/noRecord" });
          }
        })
        .catch(err => {
          this.$router.push({ path: "/noRecord" });
        });
    },
    showMore() {
      if (!this.isHasSearch) return;
      this.pageIndex += 1;
      let QueryModel = {
        TargetDate: this.TargetDate,
        IsChecked: this.IsChecked
      };
      this.getCarrierinvitationCheckList(
        this.pageIndex,
        this.pageCount,
        QueryModel
      );
    },
    search() {
      this.isHasSearch = true;
      this.pageIndex = 1;
      let QueryModel = {
        TargetDate: this.TargetDate,
        IsChecked: this.IsChecked
      };
      this.List = [];
      this.getCarrierinvitationCheckList(
        this.pageIndex,
        this.pageCount,
        QueryModel
      );
    },
    handleDateChange() {
      this.isHasSearch = false;
    },
    goTop() {
      window.scroll(0, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
.Approval-list {
  padding-bottom: 47px;
}
.fixed-con {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 48px;
  border-top: 1px solid #ccc;
  margin: 0;
  background: #fff;
  .col-4 {
    padding: 0;
    height: 48px;
    line-height: 48px;
    text-align: center;
    &.c {
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;
    }
    a {
      color: #434343;
      font-size: 14px;
      text-decoration: none;
      display: block;
    }
    .router-link-active {
      color: #fff;
      background-image: linear-gradient(73deg, #f36443, #e42029);
    }
  }
}
.go-top {
  width: 40px;
  height: 40px;
  color: #fff;
  text-align: center;
  background-image: linear-gradient(73deg, #f36443, #e42029);
  border-radius: 50%;
  line-height: 40px;
  position: fixed;
  right: 20px;
  bottom: 60px;
  .iconfont {
    font-size: 10px;
    line-height: 40px;
    vertical-align: top;
  }
}
.des {
  font-size: 13px;
  color: #666;
  text-align: center;
  padding-top: 30px;
}
h3 {
  font-size: 18px;
  padding: 20px 0 16px 15px;
  color: #434343;
  margin-bottom: 0;
  font-weight: bold;
}
.time {
  padding: 0 15px 15px 15px;
  .l,
  .r {
    display: inline-block;
    vertical-align: top;
  }
  .l {
    margin-right: 20px;
  }
}
.top-con {
  border-bottom: #ccc 1px solid;
  input {
    font-size: 14px;
    background: red;
  }
  .r {
    padding-left: 0;
  }
  .button {
    width: 50px;
    height: 24px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    background-image: linear-gradient(73deg, #f36443, #e42029);
    border-radius: 4px;
    line-height: 24px;
  }
}
.list {
  font-size: 14px;
  color: #434343;
  border-bottom: #ccc 1px solid;
  a {
    display: block;
    padding: 12px 20px;
    font-size: 14px;
    color: #434343;
    text-decoration: none;
  }
  p {
    margin-bottom: 0;
    line-height: 18px;
    color: red;
    font-size: 13px;
  }
  .r {
    font-size: 13px;
    color: #666;
    padding-right: 0;
    span {
      padding: 0 10px 0 10px;
      vertical-align: middle;
    }
    .status-grey {
      color: #666;
    }
    .status-red {
      color: red;
    }
    .status-green {
      color: #2db051;
    }
    i {
      vertical-align: middle;
      font-size: 14px;
    }
  }
}
.load-more {
  width: 88px;
  height: 30px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  background-image: linear-gradient(73deg, #f36443, #e42029);
  margin: 30px auto;
  border-radius: 4px;
  line-height: 30px;
  opacity: 0.5;
}
.rel {
  opacity: 1;
}
</style>